import React, {Component} from 'react';
import Errors from '../common/Errors'
import {Link, Redirect} from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import * as AppConstant from '../common/AppConstant'
import * as Util from '../common/Util';
import RequiredAstrisk from '../common/RequiredAstrisk'

class BlubillingConf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirectProcessorConfig: false,
            blubillingConfiguration: {
                url: "",
                username: "",
                password: "",
                confirm: "",
                disabled: false,
                enableCreateCustomer: false,
                enableCardSave: false,
                cvvRequired: false,
                allowCreateOrder: false
            },
            loggedInUser:{},
            disabledButton: false,
            redirectToDashBoard: false,
            redirectToErrorPage: false,
            redirectToForbiddenPage: false,
            apiStatus: {
                isError: false,
                message: '',
                messages: ''
            },
            errorMessage: '',
            showLoader: false
        };
        this.fetchBlubillingConf = this.fetchBlubillingConf.bind(this);
        this.checkBoxChange = this.checkBoxChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTestConnectionSubmit = this.handleTestConnectionSubmit.bind(this)
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this)
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            element: false
        });
    }

    componentDidMount() {
        this.fetchLoggedInStaff();
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchBlubillingConf();
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }
    fetchBlubillingConf() {
        this.setState({showLoader: true});
        fetch(this.props.api + '/blubillingConf', {
            method: "GET",
            mode: 'cors',
            headers: {
                "X-AUTH-TOKEN": this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json && json.isError === false) {
                    const blubillingConfiguration = json.blubillingConfiguration;
                    blubillingConfiguration["password"] = "********";
                    blubillingConfiguration["confirm"] = "********";
                    this.setState({blubillingConfiguration: blubillingConfiguration, showLoader: false});
                } else {
                    this.setState({showLoader: false});
                    if (json && json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.props.onLogoutClick(json.message);
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({redirectToForbiddenPage: true});
                    }
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({showLoader: false});
            });
    }

    handleChange(event) {
        const {blubillingConfiguration} = this.state;
        const target = event.target;
        const name = target.name;
        const value = target.value;
        blubillingConfiguration[name] = value;
        this.setState({blubillingConfiguration: blubillingConfiguration});
    }

    checkBoxChange(value, name) {
        if (value === true) {
            const {blubillingConfiguration} = this.state;
            blubillingConfiguration[name] = false;
            if(name === "enableCreateCustomer"){
                blubillingConfiguration["enableCardSave"] = false;
                blubillingConfiguration["cvvRequired"] = false;
            }
            this.setState({blubillingConfiguration: blubillingConfiguration});
        } else {
            const {blubillingConfiguration} = this.state;
            blubillingConfiguration[name] = true;
            this.setState({blubillingConfiguration: blubillingConfiguration});
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log(+this.validator.allValid());
        const {apiStatus} = this.state;
        if (this.validator.allValid()) {
            const {blubillingConfiguration} = this.state;
            if (!blubillingConfiguration.enableCreateCustomer) {
                blubillingConfiguration['enableCardSave'] = false
                this.setState({blubillingConfiguration: blubillingConfiguration});
            }
            this.setState({showLoader: true});
            fetch(this.props.api + '/blubillingConf', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.state.blubillingConfiguration),
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    if (json && json.isError === false) {
                        Util.successResponse(apiStatus, json);
                    } else {
                        Util.errorResponse(apiStatus, json);
                        if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                            this.setState({showLoader: false, redirectToForbiddenPage: true});
                        }
                    }
                    this.setState({
                        disabledButton: false,
                        redirectProcessorConfig: json.rdr,
                        apiStatus: apiStatus,
                        showLoader: false,
                        redirectToDashBoard: (apiStatus.isError === false ? true : false)
                    });
                })
                .catch(error => {
                    Util.errorCatchResponse(apiStatus, error);
                    this.setState({disabledButton: false, apiStatus: apiStatus, showLoader: false});
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handleTestConnectionSubmit() {
        console.log(this.validator.allValid());
        const {apiStatus} = this.state;
        if (this.validator.allValid()) {
            const {blubillingConfiguration} = this.state;
            if (!blubillingConfiguration.enableCreateCustomer) {
                blubillingConfiguration['enableCardSave'] = false;
                this.setState({blubillingConfiguration: blubillingConfiguration});
            }
            this.setState({showLoader: true});
            fetch(this.props.api + '/blubillingConf/testConnection', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.state.blubillingConfiguration),
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken,
                    'content-type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(json => {
                    if (json && json.isError === false) {
                        Util.successResponse(apiStatus, json);
                    } else {
                        Util.errorResponse(apiStatus, json);
                        if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                            this.setState({showLoader: false, redirectToForbiddenPage: true});
                        }
                    }
                    this.setState({
                        apiStatus: apiStatus,
                        showLoader: false
                    });
                })
                .catch(error => {
                    Util.errorCatchResponse(apiStatus, error);
                    this.setState({disabledButton: false, apiStatus: apiStatus, showLoader: false});
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        let _this = this;
        let messageForConfig = "Payment processor configuration needs to be updated.";
        return (
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToErrorPage={this.state.redirectToErrorPage}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                {
                    (this.state.redirectToDashBoard && this.state.apiStatus && this.state.apiStatus.message) ? (
                        <Redirect to={this.state.redirectProcessorConfig === true ? '/paymentProcessorConfiguration/'+messageForConfig: '/msg/' + this.state.apiStatus.message}/>) : null
                }

                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('bluConfig.label.header')}</p>
                            </div>
                            <div className="table-box table-responsive p-m" style={{ minHeight: '490px'}}>
                                <Errors errorObject={this.state.apiStatus}/>
                                {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                                <form onSubmit={this.handleSubmit} className="form-horizontal">
                                    <div className="col-md-12">
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('bluConfig.label.url')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control" id="url"
                                                           name="url" onChange={this.handleChange}
                                                           value={this.state.blubillingConfiguration.url ? this.state.blubillingConfiguration.url : ''}
                                                           autoComplete="nope"/>
                                                    <div style={{color: "red"}}>
                                                        {this.validator.message('url', this.state.blubillingConfiguration.url, 'required|url')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('bluConfig.label.userName')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="text" className="form-control" id="username"
                                                           onChange={this.handleChange}
                                                           name="username"
                                                           value={this.state.blubillingConfiguration.username ? this.state.blubillingConfiguration.username : ''}
                                                           autoComplete="nope"/>
                                                    <div style={{color: "red"}}>
                                                        {this.validator.message('username', this.state.blubillingConfiguration.username, 'required|max:255')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('bluConfig.label.password')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="password" className="form-control" id="password"
                                                           onChange={this.handleChange}
                                                           name="password"
                                                           autoComplete="off"
                                                           value={this.state.blubillingConfiguration.password ? this.state.blubillingConfiguration.password : ''}/>
                                                    <div style={{color: "red"}}>
                                                        {this.validator.message('password', this.state.blubillingConfiguration.password, 'required|max:255')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('bluConfig.label.confirm')}<RequiredAstrisk/></label>

                                                <div className="col-lg-7">
                                                    <input type="password" className="form-control" id="confirm"
                                                           onChange={this.handleChange}
                                                           name="confirm"
                                                           autoComplete="off"
                                                           value={this.state.blubillingConfiguration.confirm ? this.state.blubillingConfiguration.confirm : ''}/>
                                                    <div style={{color: "red"}}>
                                                        {this.validator.message('confirm password', this.state.blubillingConfiguration.confirm,
                                                            `required|in:${this.state.blubillingConfiguration.password}`, {messages: {in: 'Passwords need to match!'}})}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('bluConfig.label.disable')}</label>

                                                <div className="col-lg-1">
                                                    <div className="switch">
                                                        <div className="onoffswitch">
                                                            <input
                                                                type="checkbox" id="disabled" name="disabled" className="onoffswitch-checkbox"
                                                                checked={_this.state.blubillingConfiguration.disabled}
                                                                onChange={(e) => _this.checkBoxChange(_this.state.blubillingConfiguration.disabled, 'disabled')}/>
                                                                <label className="onoffswitch-label" htmlFor="disabled">
                                                                    <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                                    <span className="onoffswitch-switch"></span>
                                                                </label>
                                                        </div>
                                                    </div>
                                                    {/**/}
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('bluConfig.label.enableCreateCustomer')}</label>

                                                <div className="col-lg-1">
                                                    <div className="switch">
                                                        <div className="onoffswitch">
                                                            <input
                                                                type="checkbox" id="enableCreateCustomer" className="onoffswitch-checkbox"
                                                                name="enableCreateCustomer"
                                                                checked={_this.state.blubillingConfiguration.enableCreateCustomer}
                                                                onChange={(e) => _this.checkBoxChange(_this.state.blubillingConfiguration.enableCreateCustomer, 'enableCreateCustomer')}/>
                                                            <label className="onoffswitch-label" htmlFor="enableCreateCustomer">
                                                                <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                                <span className="onoffswitch-switch"></span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            { _this.state.blubillingConfiguration.enableCreateCustomer ? <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('bluConfig.label.savePaymentMethod')}</label>

                                                <div className="col-lg-1">
                                                    <div className="onoffswitch">
                                                        <input
                                                            type="checkbox" id="enableCardSave" name="enableCardSave" className="onoffswitch-checkbox"
                                                            checked={_this.state.blubillingConfiguration.enableCardSave}
                                                            onChange={(e) => _this.checkBoxChange(_this.state.blubillingConfiguration.enableCardSave, 'enableCardSave')}/>
                                                        <label className="onoffswitch-label" htmlFor="enableCardSave">
                                                            <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                            <span className="onoffswitch-switch"></span>
                                                        </label>
                                                    </div>

                                                </div>
                                            </div> : ''}
                                            { _this.state.blubillingConfiguration.enableCreateCustomer ? <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>CVV Required</label>

                                                <div className="col-lg-1">
                                                    <div className="onoffswitch">
                                                        <input
                                                            type="checkbox" id="cvvRequired" name="cvvRequired" className="onoffswitch-checkbox"
                                                            checked={_this.state.blubillingConfiguration.cvvRequired}
                                                            onChange={(e) => _this.checkBoxChange(_this.state.blubillingConfiguration.cvvRequired, 'cvvRequired')}/>
                                                        <label className="onoffswitch-label" htmlFor="cvvRequired">
                                                            <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                            <span className="onoffswitch-switch"></span>
                                                        </label>
                                                    </div>

                                                </div>
                                            </div> : ''}

                                            <div className="form-group row">
                                                <label className="col-lg-4 control-label"
                                                       style={{textAlign: 'left'}}>{_this.props.msg('bluConfig.label.allowCreateOrder')}</label>

                                                <div className="col-lg-1">
                                                    <div className="switch">
                                                        <div className="onoffswitch">
                                                            <input
                                                                type="checkbox" id="allowCreateOrder" className="onoffswitch-checkbox"
                                                                name="allowCreateOrder"
                                                                checked={_this.state.blubillingConfiguration.allowCreateOrder}
                                                                onChange={(e) => _this.checkBoxChange(_this.state.blubillingConfiguration.allowCreateOrder, 'allowCreateOrder')}/>
                                                            <label className="onoffswitch-label" htmlFor="allowCreateOrder">
                                                                <span className="onoffswitch-inner yesnoswitch-inner"></span>
                                                                <span className="onoffswitch-switch"></span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="form-group">
                                        <div className="col-lg-offset-2 col-lg-10">
                                            <Link to="/"
                                                  className="btn btn-white" style = {{marginLeft: '18px'}}>
                                                {_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                            <input className="btn btn-primary" type="submit"
                                                   value={_this.props.msg('form.label.submit')}
                                                   disabled={this.state.disabledButton === true}/>&nbsp;&nbsp;&nbsp;
                                            <button type="button" className="btn btn-primary" onClick={_this.handleTestConnectionSubmit}
                                                    disabled={this.state.disabledButton === true}>{_this.props.msg('bluConfig.label.testConnection')}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BlubillingConf;


// WEBPACK FOOTER //
// ./src/components/organization/BlubillingConf.js